import { useMemo } from 'react';

export function useHeroStats() {
  return useMemo(() => ({
    count: 500,
    text: 'professionals'
  }), []);
}